import {t} from '../../../common/getTranslations';
import {getPeriodText} from '../../../common/shared/utils/getPeriodText';

export function BuyTicketRegulation({
  className,
  rentalPeriodByMinute,
}: {
  className: string;
  rentalPeriodByMinute: number;
}) {
  return (
    <div className={className}>
      <span className="font-small2-bold mt-8pxr text-theme-solid-100">
        {t('ticket_purchase_regulation')}
      </span>
      <ul className="font-small2 text-theme-solid-60">
        <li className="flex gap-x-4pxr">
          <span>·</span>
          <span>{t('ticket_purchase_regulation_1')}</span>
        </li>
        <li className="mt-8pxr flex gap-x-4pxr">
          <span>·</span>
          <span>
            {t('ticket_purchase_regulation_2', {
              values: {
                value: getPeriodText(rentalPeriodByMinute),
              },
            })}
          </span>
        </li>
        <li className="mt-8pxr flex gap-x-4pxr">
          <span>·</span>
          <span>{t('ticket_purchase_regulation_3')}</span>
        </li>
        <li className="mt-8pxr flex gap-x-4pxr">
          <span>·</span>
          <span>{t('ticket_purchase_regulation_4')}</span>
        </li>
        <li className="mt-8pxr flex gap-x-4pxr">
          <span>·</span>
          <span>{t('ticket_purchase_regulation_5')}</span>
        </li>
        <li className="mt-8pxr flex gap-x-4pxr">
          <span>·</span>
          <span>{t('ticket_purchase_regulation_6')}</span>
        </li>
        <li className="mt-8pxr flex gap-x-4pxr">
          <span>·</span>
          <span>{t('ticket_purchase_regulation_7')}</span>
        </li>
        <li className="mt-8pxr flex gap-x-4pxr">
          <span>·</span>
          <span>{t('ticket_purchase_regulation_8')}</span>
        </li>
        <li className="mt-8pxr flex gap-x-4pxr">
          <span>·</span>
          <span>{t('ticket_purchase_regulation_9')}</span>
        </li>
        <li className="mt-8pxr flex gap-x-4pxr">
          <span>·</span>
          <span>{t('ticket_purchase_regulation_10')}</span>
        </li>
        <li className="mt-8pxr flex gap-x-4pxr">
          <span>·</span>
          <span>{t('ticket_purchase_regulation_11')}</span>
        </li>
      </ul>
    </div>
  );
}
